import { render, staticRenderFns } from "./pagamentoCartao.vue?vue&type=template&id=0f0d9e90&scoped=true&"
import script from "./pagamentoCartao.vue?vue&type=script&lang=js&"
export * from "./pagamentoCartao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d9e90",
  null
  
)

export default component.exports